import { render } from "./MediaSelector.vue?vue&type=template&id=197b2c60&scoped=true"
import script from "./MediaSelector.vue?vue&type=script&lang=js"
export * from "./MediaSelector.vue?vue&type=script&lang=js"

import "./MediaSelector.vue?vue&type=style&index=0&id=197b2c60&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-197b2c60"]])

export default __exports__